import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { BaseWalletService } from '../http/base-wallet.service';
import { LaunchGameResponse } from './game.models';
import { LAUNCH_GAME } from '../http/base-http.service';
import { HOST_NAME } from 'src/app/global.tokens';

const PLAYNGO_LAUNCH_DOMAIN = 'https://acccw.playngonetwork.com';
const PLAYNGO_PROXY_DOMAIN = 'https://playngo-proxy-l3nqj7rrwq-lz.a.run.app';

const GAME_IDS_EXCLUDED_FROM_PROXYING = [170121, 170122, 170045, 170142];

@Injectable({
  providedIn: 'root'
})
export class GameLauncherService extends BaseWalletService {

  constructor(
    http: HttpClient,
    cookie: CookieService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(HOST_NAME) public hostName: string
  ) {
    super(http, cookie, locale, hostName);
  }

  public requestStartGame(gameId: string, isMobile: boolean = true): Observable<LaunchGameResponse> {
    console.log('gameId', gameId);
    const url = LAUNCH_GAME + gameId + '/';
    let params = new HttpParams();

    if (isMobile) {
      params = params.set('is_mobile', isMobile.toString());
      params = params.set('redirect_after_game_close', `https://${this.hostName}`);
    }
    return this.getRequestHttpParams<LaunchGameResponse>(url, params).pipe(
      take(1),
      map((resp) => {
        // if (this.shouldProxyGame(+gameId)) {
        //   resp.config.game_url = resp.config.game_url.replace(PLAYNGO_LAUNCH_DOMAIN, PLAYNGO_PROXY_DOMAIN);
        // }
        return resp;
      })
    );
  }

  private shouldProxyGame(gameId: number): boolean {
    return !GAME_IDS_EXCLUDED_FROM_PROXYING.includes(gameId);
  }
}
